import { render, staticRenderFns } from "./ListaAtividadeDisciplinaObjetivo.vue?vue&type=template&id=556b8e47"
import script from "./ListaAtividadeDisciplinaObjetivo.vue?vue&type=script&lang=js"
export * from "./ListaAtividadeDisciplinaObjetivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports